module.exports = __webpack_public_path__ + "img/ai-generated-icon.f2c786b5.svg";